import styled from "styled-components";

export const AdminActionsWrapper = styled.div``;